import { formatVndInput, parseVndInput } from './vndFormat';

export function calcContractAmountsFromInclusive(valueWithVat: number, vatPercent: number) {
  if (valueWithVat <= 0 || vatPercent < 0) {
    return { valueBeforeVat: 0, totalVat: 0 };
  }
  const valueBeforeVat = Math.round(valueWithVat / (1 + vatPercent / 100));
  const totalVat = valueWithVat - valueBeforeVat;
  return { valueBeforeVat, totalVat };
}

export function formatContractAmountField(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const numeric = typeof value === 'number' ? value : Number(String(value).replace(/\./g, ''));
  if (!Number.isFinite(numeric)) return '';
  return formatVndInput(numeric);
}

export function parseContractAmountField(value: string): number {
  return parseVndInput(value) ?? 0;
}
